import { unstable_composeClasses as composeClasses } from '@mui/material';
import { capitalize } from '@mui/material/utils';
import clsx from 'clsx';
import { forwardRef } from 'react';

import {
  LabelColor,
  LabelRoot,
  LabelSize,
  LabelVariant,
  LabelBorderType,
  type LabelProps,
} from './label-base';
import { getLabelUtilityClass, type LabelClasses, type LabelClassKey } from './label-classes';

function useUtilityClasses(ownerState: LabelProps) {
  const {
    classes,
    color = LabelColor.PRIMARY,
    variant = LabelVariant.CONTAINED,
    size = LabelSize.MEDIUM,
  } = ownerState;

  const slots = {
    root: [
      'root',
      variant,
      `${variant}${capitalize(color)}`,
      `size${capitalize(size)}`,
      `${variant}Size${capitalize(size)}`,
    ],
    startIcon: ['startIcon', `iconSize${capitalize(size)}`],
    endIcon: ['endIcon', `iconSize${capitalize(size)}`],
  };

  return composeClasses(slots, getLabelUtilityClass, classes);
}

const Label = forwardRef((props: LabelProps, ref) => {
  const { root: classesRoot, ...classes } = useUtilityClasses(props);
  const { className, children, startIcon, endIcon, color, variant, size } = props;

  const ownerState = {
    color,
    variant,
    size,
  };

  return (
    <LabelRoot
      {...props}
      {...ownerState}
      ref={ref}
      className={clsx(classesRoot, className)}
      classes={classes}
    >
      {startIcon}
      {children}
      {endIcon}
    </LabelRoot>
  );
});
Label.displayName = 'Label';

export { Label, LabelColor, LabelSize, LabelVariant, LabelBorderType };
export type { LabelClasses, LabelClassKey, LabelProps };
